import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CCasesDynamiquesEditionComponent } from './c-cases-dynamiques-edition.component';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { AsInstanceOfFormElementModule } from 'src/app/pipes/as-instance-of-form-element/as-instance-of-form-element.module';



@NgModule({
  declarations: [CCasesDynamiquesEditionComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    IonicModule,
    AsInstanceOfFormElementModule
  ],
  exports: [CCasesDynamiquesEditionComponent]
})
export class CCasesDynamiquesEditionModule { }
